import { render } from "./ChatChannel.vue?vue&type=template&id=e9ba7cec&scoped=true"
import script from "./ChatChannel.vue?vue&type=script&lang=ts"
export * from "./ChatChannel.vue?vue&type=script&lang=ts"

import "./ChatChannel.vue?vue&type=style&index=0&id=e9ba7cec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e9ba7cec"

export default script